// @flow
import * as React from 'react';
import { setConfigOnce } from 'utils/config';

const WithConfig = ({
  config,
  children
}: {
  config: Object,
  children: React.Node
}) => {
  setConfigOnce(config);
  return children;
};

export default WithConfig;
